import { motion } from "framer-motion";

/**
 * AIThinkingOrb — a breathing, glowing blurred orb that signals
 * "AI is thinking". Used as our branded loader (replaces spinners).
 */
export function AIThinkingOrb({ size = 72, label = "", className = "", testid = "ai-thinking-orb" }) {
  return (
    <div
      className={`inline-flex flex-col items-center gap-4 ${className}`}
      data-testid={testid}
    >
      <span className="relative inline-flex" style={{ width: size, height: size }}>
        <motion.span
          className="absolute inset-0 rounded-full"
          style={{
            background:
              "radial-gradient(circle at 35% 35%, #FF4F27 0%, #E1FF00 60%, transparent 75%)",
            filter: "blur(12px)",
          }}
          animate={{ scale: [1, 1.18, 1], opacity: [0.6, 1, 0.6] }}
          transition={{ duration: 2.2, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.span
          className="absolute inset-2 rounded-full bg-ink-950"
          animate={{ scale: [1, 0.9, 1] }}
          transition={{ duration: 2.2, repeat: Infinity, ease: "easeInOut" }}
        />
      </span>
      {label && (
        <span className="text-xs font-bold uppercase tracking-[0.22em] text-ink-500">
          {label}
        </span>
      )}
    </div>
  );
}
